<template>
  <div class='xy-content-module'>
    <div class='xy-content-title xy-flex xy-between xy-center'>
      <div><!--这里是按钮 --></div>
      <div><!--这里是右侧的筛选 --></div>
    </div>
    <div class='xy-content-body'>
      <!-- 校区、年级选择 -->
      <div class="changeAll" >
        <div class="chang-school" @click="showSchool">
          <span>{{schoolName ? schoolName:''}}</span>
          <img src="./img/down.png" alt="" >
        </div>
        <div class="chang-grade" @click="showGrade">
          <span>{{gradeName ? gradeName: ''}}</span>
           <img src="./img/down.png" alt="" >
        </div>
      </div>
      <van-popup v-model="isShowschool" position="bottom" :style="{ height: '50%' }" >
        <div style="text-align: center;" v-for="(item,index) in layerList" :key="index" @click="changeSchool(item,'checked')">
          <div style="font-size:18Px;padding:18px">{{item.label}}</div>
        </div>
      </van-popup>
      <van-popup v-model="isShowgrade" position="bottom" :style="{ height: '50%' }"  @click-overlay="onGrade">
        <div style="text-align: center;" v-for="(item,index) in layerListGrade" :key="index" @click="changeGrade(item)">
          <div style="font-size:18Px;padding:18px">{{item.label}}</div>
        </div>
      </van-popup>
      <div class="assessView null-data" v-if="list.length === 0 && isLoad">
        <img src="@/assets/common/moblie-no-data.png" />
        <div>该搜索条件下暂无结果。</div>
      </div>
      <!-- 指标列 -->
      <div class="index-box" v-for="(i, j) in list" :key="j">
        <div class="sec-index">{{i.label}} </div>
        <ul class="th-index-list">
      <!-- 无三级指标 -->
          <li class="th-index" v-if="i.children.length === 0">
            <van-checkbox style="border-radius: 2px" icon-size="22" checked-color="#1677FF" shape="square" v-model="i.checked" @click="ischeck(i, false)"></van-checkbox>
            <div class="index-li">
              <p class="index-txt">{{i.label}} </p>
              <div @click="clear(i)" v-if="i.ScoreType === 1">
                <van-rate @change="ischeck(i, true)" v-model="i.scoredefault" :count="i.scoremax" :void-icon="rateUrl" color="#FADB14" :size="26" />
              </div>
              <div class="score-slider" v-else>
                <span>{{i.scoremin}}分</span>
                <van-slider @change="ischeck(i, true)" :min="i.scoremin" :max="i.scoremax" v-model="i.scoredefault" bar-height="10px" active-color="#4196FF">
                  <template #button>
                    <div class="seekBar">
                      <div class="bubble">{{i.scoredefault}}分 </div>
                    </div>
                  </template>
                </van-slider>
                <span>{{i.scoremax}}分</span>
              </div>
            </div>
          </li>
      <!-- 有三级指标 -->
          <li class="th-index" v-else v-for="(item, index) in i.children" :key="index">
            <van-checkbox style="border-radius: 2px" icon-size="22" checked-color="#1677FF" shape="square" v-model="item.checked" @click="ischeck(item, false)"></van-checkbox>
            <div class="index-li">
              <p class="index-txt">{{item.label}} </p>
              <div @click="clear(item)" v-if="i.ScoreType === 1">
                <van-rate @change="ischeck(item, true)" v-model="item.scoredefault" :count="item.scoremax" :void-icon="rateUrl" color="#FADB14" :size="26" />
              </div>
              <div class="score-slider" v-else>
                <span>{{item.scoremin}}分</span>
                <van-slider @change="ischeck(item, true)" :min="item.scoremin" :max="item.scoremax" v-model="item.scoredefault" bar-height="10px" active-color="#4196FF">
                  <template #button>
                    <div class="seekBar">
                      <div class="bubble">{{item.scoredefault}}分 </div>
                    </div>
                  </template>
                </van-slider>
                <span>{{item.scoremax}}分</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="sigle-bottom-btn">
      <div class="select-class" @click="checkClass">选择班级</div>
    </div>
    <div v-if="showCover" class="showCover">
      <van-popup v-model="showCover">
        <div class="mask">
          <img src="./img/notice.png" alt="">
          <div class="text">为了更好的使用，请您横屏使用</div>
          <div class="close" @click="showCover =  false">
            知道了
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
  import { Toast } from 'vant'
  export default {
    name: 'MoralEducation',
    data () {
      return {
        num:0,
        schoolgradeId:'',
        name:'',
        rateUrl: require('./img/voidRate.png'),
        // 指标
        list: [],

        // 校区弹出层
        layerList:[],
        layerListGrade:[],
        schoolName:'',
        gradeName:'',
        className:'',
        show:false,
        isShowschool:false,
        isShowgrade:false,
        // 选择校区年级
        schoolId: 0,
        gradeId: 0,
        ScoreType: 0,
        scoreDatas: [],

        // 判断是否加载完
        isLoad: false,
        dItem: 0,
        minItem: 0,
        oldSchoolData:[],
        showCover:false
      }
    },
    // beforeRouteEnter(to, from, next) {
    //   next(vm=>{
    //       let schoolgradeId = JSON.parse(localStorage.getItem("schoolgradeId"))
    //       if(from.name === 'MoralClassList'){
    //         vm.GetUserRangeClassPermission(schoolgradeId)
    //       }else{
    //         vm.GetUserRangeClassPermission()
    //       }
    //     })
    // },
     beforeRouteEnter(to, from, next) {
      next(vm=>{
          vm.schoolgradeId = JSON.parse(localStorage.getItem("schoolgradeId"))
          vm.name = from.name
          // let schoolgradeId = JSON.parse(localStorage.getItem("schoolgradeId"))
          let width = document.documentElement.clientWidth;
          let height = document.documentElement.clientHeight;
          if(height<width){
            vm.getList()           
          }
        })
    },
    mounted() {
      window.addEventListener("resize", this.watch, false);
      this.watch();
    },
    beforeDestroy() {
    // 移除监听
      window.removeEventListener("resize", this.watch, false);
    },
    methods: {
      getList(){
        if(this.name === 'MoralClassList'){
          console.log(':.？？？？？？')
          this.GetUserRangeClassPermission(this.schoolgradeId)
        }else{
          this.GetUserRangeClassPermission()
        }
      },
      watch(){
        console.log("?????????")
        // if(!window.isIpad){
          // 判断横竖屏
          let width = document.documentElement.clientWidth;
          let height = document.documentElement.clientHeight;
          if(height>width){
            this.showCover = true
          }else{
            this.showCover = false
            this.num++    //
            if(this.num === 1){ //一的时候是横屏  0的时候是竖屏
               this.getList()
            } 
          }
        // }
      },
      loading() {
        Toast.loading({
          message: '加载中...',
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      fail(a) {
        Toast.fail({
          message: a,
          className: 'ipad_toast',
          forbidClick: true
        })
      },
      // 跳转 - 选择班级
      checkClass () {
        if (this.scoreDatas.length !== 0) {
          localStorage.setItem("schoolgradeId", JSON.stringify({"schoolId": this.schoolId,"schoolName":this.schoolName,"gradeId": this.gradeId,"gradeName":this.gradeName}))
          this.$router.push({
            path: "/ipad/MoralClassList",
            query: {
              schoolId: this.schoolId,
              gradeId: this.gradeId,
              gradeName: this.gradeName,
              scoreDatas: this.scoreDatas
            }
          })
        } else {
          this.fail("请先选择指标。")
        }
      },
      showSchool(){
        this.isShowschool = true
        this.isShowgrade = false
      },
      showGrade(){
        this.isShowschool = false
        this.isShowgrade = true
      },
      //获取校区
      async GetUserRangeClassPermission(schoolgradeData) {
        this.loading()
        let idArr = this.$store.state.evaluation.ipadpjgetMenuIDs
        this.applicationID = idArr[0]
        this.applicationSubMenuID = idArr[1]
        let res = await this.xyapi.get(
          `${this.xyMApi}/eva/api/MoralScoreRecordByPad/GetUserRangeClassPermissionNodeListByProgrammeByPad`,
          {
            applicationID: this.applicationID,
            applicationSubMenuID: this.applicationSubMenuID,
            Dimension: 0
          }
        )
        this.xy.unloading()
        if (res.success) {
          let layerList = []
          layerList = res.data;
          if (layerList.length > 0) {
            this.layerList = layerList
            //默认调用changeSchool
            if (schoolgradeData === undefined){
                this.changeSchool(this.layerList[0])
            }else{
                for(var i=0;i<this.layerList.length;i++){
                  if (this.layerList[i].value === schoolgradeData.schoolId){
                    this.changeSchool(this.layerList[i],'checked')
                    for(var n=0;n<this.layerList[i].children.length;n++){
                      if (this.layerList[i].children[n].value === schoolgradeData.gradeId){
                        this.changeGrade(this.layerList[i].children[n])
                      }
                    }
                  }
                }
            }
            
          } else {
            this.fail("您无有效的年级班级");
          }
        } else {
          this.fail(res.msg);
        }
      },
      // 获取指标
      async GetClassIndex() {
        this.loading()
        let res = await this.xyapi.get(
          `${this.xyMApi}/eva/api/MoralScoreRecordByPad/GetClassIndexManagementListByPad`,
          {
            SchoolDistrictID: this.schoolId,
            StudentGradeForStudentYearID: this.gradeId,
            Dimension: 0
          }
        )
        this.xy.unloading()
        if (res.success) {
          this.list = res.data
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].children.length !== 0) {
              this.list[i].children.map((item) => {
                this.$set(item, 'checked', false)
                this.$set(item, 'isChange', false)
              })
            } else {
              this.$set(this.list[i], 'checked', false)
              this.$set(this.list[i], 'isChange', false)
            }
          }
          this.isLoad = true
        }
      },
      //选择校区
      changeSchool(item,ischeck){
        this.schoolName = item.label
        this.schoolId = item.value
        this.isShowschool = false
        this.layerListGrade = item.children
        if(ischeck === 'checked'){
          this.isShowgrade = true
        }else{
          //默认选择第一个
          this.gradeName = this.layerListGrade.length>0 ? this.layerListGrade[0].label : ''
          this.gradeId = this.layerListGrade[0].value
          this.changeGrade(this.layerListGrade[0])
        }
      },
      //选择年级
      changeGrade(item){
        this.gradeName = item.label
        this.gradeId = item.value
        this.isShowgrade = false
        this.layerListClass = item.children
        this.GetClassIndex()
        this.oldSchoolData = {
          sName:this.schoolName,
          sId:this.schoolId,
          sList:this.layerList,
          gName:this.gradeName,
          gId:this.gradeId,
          gList:this.layerListGrade
        }
      },
      onGrade(){
        this.schoolName = this.oldSchoolData.sName
        this.schoolId = this.oldSchoolData.sId
        this.layerList = this.oldSchoolData.sList
        this.gradeName = this.oldSchoolData.gName
        this.gradeId = this.oldSchoolData.gId
        this.layerListGrade = this.oldSchoolData.gList
      },
      // 选择指标
      ischeck (item, sel) {
        this.dItem = item.scoredefault
        this.minItem = item.scoremin
        item.isChange = item.scoredefault === 1 ? true : false
        //默认值小于设置的最小值时 取消选中
        if (item.scoredefault < item.scoremin) {
          item.checked = false
          let ins = -1
          for(let i=0,len=this.scoreDatas.length;i<len;i++){
            if(!this.scoreDatas[i].checked){
              ins=i
            }
          }
          if(ins!==-1){ this.scoreDatas.splice(ins,1) }
          this.fail(`指标项评价最小值为${item.scoremin}`)
          return false
        }
        setTimeout(() => {
          item.isChange = item.scoredefault === 1 ? false : true
          if (sel && !item.checked) {
            item.checked = true
            this.scoreDatas.push(item)
          } else if (!sel) {
            let indexs = -1
            item.checked = item.checked ? false :true
            item.checked = !item.checked ? true :false
            if (item.checked) {
              this.scoreDatas.push(item)
            }else{
              for(let i=0,len=this.scoreDatas.length;i<len;i++){
                if(this.scoreDatas[i].value ===item.value){
                  indexs=i
                }
              }
            }
            if(indexs!==-1)
              this.scoreDatas.splice(indexs,1)     
          }
        }, 100)
      },
      // 清除选择
      clear (item) {
        // 原本等于1 或者 改变得分为1后再次点击
        if (item.scoredefault === 1 && !item.isChange) {
          item.scoredefault = 0
          this.dItem = item.scoredefault
          this.minItem = item.scoremin
          if (item.scoredefault >= item.scoremin) {
            item.checked = true
            item.isChange = false
            this.scoreDatas.push(item)
          } else {
            item.checked = false
            let ins = -1
            for(let i=0,len=this.scoreDatas.length;i<len;i++){
              if(!this.scoreDatas[i].checked){
                ins=i
              }
            }
            if(ins!==-1){ this.scoreDatas.splice(ins,1) }
            this.fail(`指标项评价最小值为${item.scoremin}`)
            return false
          }
        }
      }
    }
  }
</script>
<style lang='less' scoped>
.xy-content-body {
  margin-bottom: 160px;
  /deep/ img {
    vertical-align: baseline !important;
  }
}
/deep/ .van-rate__item {
  padding-left: 10px;
  padding-right: 0;
}
.assessView {
  width: 100%;
  height: 670px;
}
.null-data {
  margin-top: 100px;
  text-align: center;
  div {
    // prettier-ignore
    font-size:18Px;
  }
}
.changeAll{
  background: #fff;
  height: 44px;
  width: 100%;
  font-size: 15Px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: rgba(0,0,0,0.65);
  div{
    padding:10px;
    flex: 1;
    text-align: center;
    img{
      width:10px;
      height:6px;
      margin-left:5px;
    }
  }
}
.index-box {
  .sec-index {
    font-size: 16Px;
    margin: 10px 0;
    padding-left: 50px;
    color: rgba(0,0,0,0.35);
  }
  .th-index-list {
    padding: 0 10px 0 15px;
    .th-index {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .index-li {
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 962px;
        margin-left: 15px;
        height: 116px;
        padding: 20px 30px 20px 19px;
        border-radius: 4px;
        p {
          font-size: 16Px;
          color: rgba(26,26,26,0.85);
          font-weight: bold;
          height: 76px;
          width: 460px;
        }
        .score-slider {
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            font-size: 16Px;
            color: rgba(0,0,0,0.45);
            display: inline-block;
          }
          .seekBar {
            width: 36px;
            height: 36px;
            background: url(./img/score.png) no-repeat top left;
            background-size: 36px;
            position: relative;
            .bubble {
              width: 48px;
              height: 36px;
              background: url(./img/bubble.png) no-repeat;
              color: #1677FF;
              font-size: 16Px;
              text-align: center;
              line-height: 30px;
              position: absolute;
              left: -5px;
              top: -36px;
            }
          }
          /deep/ .van-slider {
            width: 164px;
            margin: 0 18px 0 18px;
          }
        }
      }
    }
    .custom-button {
      width: 24px;
      color: #fff;
      font-size: 10Px;
      line-height: 24px;
      text-align: center;
      background-color: #4196FF;
      border-radius: 100%;
    }
  }
}

.sigle-bottom-btn {
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  z-index: 99999 !important;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 30px;
  .select-class {
    font-size: 16Px;
    color: #1677ff;
  }
  .info-btn {
    width: 74px;
    height: 32px;
    background: #1677ff;
    color: #fff;
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 14Px;
  }
}

.mask{
  width: 600px;
  height: 365px;
  background: #ffffff;
  border-radius: 12px;
  position: relative;
  img{
    position: absolute;
    top: -82px;
    left: 50%;
    width:162px;
    height: 202px;
    transform: translate(-50%,7px)
  }
  .text{
    font-size: 30px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    color: #2b2b2b;
    padding-top: 141px;
  }
  .close{
    margin:70px auto;
    width: 200px;
    height: 70px;
    background: #1677ff;
    border-radius: 35px;
    font-size: 30px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color:#fff;
    text-align: center;
    line-height: 70px;
  }
}
.showCover{
  /deep/ .van-popup{
  overflow-y: inherit;
  }
}
</style>
